import React from 'react';
import { Instagram as InstagramIcon, Play, ExternalLink } from 'lucide-react';
import { instagramPosts } from '../data/mock';

const Instagram = () => {
  if (!instagramPosts || instagramPosts.length === 0) {
    return null;
  }

  return (
    <section id="instagram" className="py-32 bg-black relative overflow-hidden">
      {/* Decorative Lines */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-400/20 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-400/20 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-gold-400 text-xs font-medium tracking-[0.3em] uppercase mb-6 block">
            Pratite nas
          </span>
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-light text-gold-400 mb-6">
            <span className="text-gold-gradient">Snimci</span>
          </h2>
          <div className="w-16 h-[1px] bg-gold-400 mx-auto mb-8" />
          <p className="text-gold-400/60 max-w-2xl mx-auto text-lg font-light">
            Pogledajte naše nastupe na Instagramu
          </p>
        </div>

        {/* Instagram Posts Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
          {instagramPosts.map((post, index) => (
            <a
              key={index}
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full max-w-[350px] group"
            >
              <div className="aspect-[9/16] bg-neutral-900 border border-gold-400/20 relative overflow-hidden hover:border-gold-400/50 transition-all duration-300">
                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6 bg-gradient-to-b from-black/20 via-transparent to-black/40">
                  <div className="w-20 h-20 rounded-full border-2 border-gold-400/50 flex items-center justify-center mb-6 group-hover:border-gold-400 group-hover:bg-gold-400/20 group-hover:scale-110 transition-all duration-300">
                    <Play className="w-8 h-8 text-gold-400 ml-1" />
                  </div>
                  <p className="text-gold-400/80 text-sm mb-3 group-hover:text-gold-400 transition-colors">Pogledaj snimak</p>
                  <div className="flex items-center gap-2 text-gold-400/60 text-xs">
                    <InstagramIcon className="w-4 h-4" />
                    <span>@bend_kockasecera</span>
                  </div>
                </div>
                
                {/* External Link Icon */}
                <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <ExternalLink className="w-5 h-5 text-gold-400" />
                </div>

                {/* Bottom Gradient */}
                <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
            </a>
          ))}
        </div>

        {/* Follow Button */}
        <div className="text-center mt-16">
          <a
            href="https://www.instagram.com/bend_kockasecera/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 btn-gold px-8 py-4 text-sm tracking-[0.15em] uppercase"
          >
            <InstagramIcon className="w-5 h-5" />
            Pratite nas na Instagramu
          </a>
        </div>
      </div>
    </section>
  );
};

export default Instagram;
